import { render } from "./PartnerDocuments.vue?vue&type=template&id=77720bf3&scoped=true"
import script from "./PartnerDocuments.vue?vue&type=script&lang=js"
export * from "./PartnerDocuments.vue?vue&type=script&lang=js"

import "./PartnerDocuments.vue?vue&type=style&index=0&id=77720bf3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77720bf3"]])

export default __exports__